<template>
  <div>
    <v-pagination
      id="paginate.navigation"
      v-model="localCurrent_page"
      :length="last_page"
      :total-visible="8"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  props: {
    current_page: {
      type: Number,
      required: true,
    },
    last_page: {
      type: Number,
      required: true,
    },
    pageNumber: {
      type: Number,
      required: true,
    },
    search: {
      type: String,
      required: true,
    },
  },
  watch: {
    current_page(value) {
      if (value === this.localCurrent_page) return;
      this.syncingFromProp = true;
      this.localCurrent_page = value;
    },
    localCurrent_page(newVal) {
      if (this.syncingFromProp) {
        this.syncingFromProp = false;
        return;
      }
      this.$emit("changeActionResponse", newVal, this.search);
    },
  },
  data() {
    return {
      localCurrent_page: this.current_page,
      syncingFromProp: false,
    };
  },
};
</script>
